const RECURSIVE_LIMIT = 10;

/**
 * Use to recursively decode a URL string to prevent against malicious encoded code
 * XSS attacks. This will decode the string until it cannot be decoded further.
 * @param str The URL string to decode.
 * @returns {string} The fully decoded URL string.
 */
export const recursiveDecodeURIComponent = (url: string): string => {
  let cycle = 0;

  const decode = (encoded: string) => {
    const decoded = decodeURIComponent(encoded);

    if (decoded !== encoded && cycle <= RECURSIVE_LIMIT) {
      cycle += 1;
      return decode(decoded);
    }

    return decoded;
  };

  return decode(url);
};
